import { Component, OnInit, ViewChild } from '@angular/core';
import { AuthService } from '../services/auth.service';
import { NgOtpInputComponent } from 'ng-otp-input';

@Component({
  selector: 'app-confirmation',
  templateUrl: './confirmation.component.html',
  styleUrls: ['./confirmation.component.scss'],
})
export class ConfirmationComponent implements OnInit {
  @ViewChild(NgOtpInputComponent, { static: false }) ngOtpInput:
    | NgOtpInputComponent
    | any;

  // User Confirmation Stuff
  signupStatus = false;
  otpValue: any = '';
  config = {
    length: 4,
    inputStyles: {
      width: '35px',
      height: '35px',
    },
  };
  user: any = {};

  constructor(private authService: AuthService) {}

  ngOnInit(): void {
    this.signupStatus = this.authService.signupStatus;
    this.authService.resendOTP({ user: this.authService.unconfirmedUserId });
  }

  onOtpChange(event: any): void {
    this.otpValue = event;
  }

  resendOtp(): void {
    this.ngOtpInput.setValue(undefined);
    if (!this.authService.isConfirmed) {
      this.signupStatus = this.authService.signupStatus;
      this.authService.resendOTP({ user: this.authService.unconfirmedUserId });
    } else {
      this.authService.resendOTP({ user: this.user._id });
    }
  }

  async verifyOtp(): Promise<any> {
    if (!this.authService.isConfirmed) {
      const obj = {
        email: this.authService.unconfirmedUser.email,
        otp: this.otpValue,
      };
      await this.authService.otp(obj);
    } else {
      const obj = {
        email: this.user.email,
        otp: this.otpValue,
      };
      await this.authService.otp(obj);
    }
  }
}
